import Steps from './Steps';
import Step from './Step';

Steps.Step = Step;

export { Step };
export default Steps;


//////////////////
// WEBPACK FOOTER
// ./node_modules/.3.1.1@rc-steps/es/index.js
// module id = 782
// module chunks = 1